/**
 * Metin içinden assembly SN (dosya adı, form alanı, excel hücresi): 6 ya da 7 haneli ana numara + ek
 * (1310530-1; B3 / ex-Transocean kitaplarında 156210-1) ya da XX-1234. Sayısal biçim önce aranır; baştaki tek
 * sıfır ("01310530-1") ve ekteki sıfır dolgusu ("156210-01") atılır. Uzun numaraların (PO, WO, 8 hane) içinden
 * SN kesilmez; harfli biçim yalnız kelime sınırında alınır ("SN-0130", "PO-4500", "ISO-9001" SN değildir).
 *
 * Sunucu (MRB yükleme) ve tarayıcı (toplu yüklemede PDF ile excel'i eşleme, D-060) aynı kuralı kullanır.
 */
export function mrbSnBul(metin) {
    const t = (metin ?? "").toUpperCase();
    // Sipariş/iş emri numarası SN değildir: önünde PO, WO ya da ORDER etiketi olan sayı alınmaz.
    const s = /(?<!(?:\bP\.?O|\bW\.?O|ORDER)[\s#:.-]*)(?<!\d)0?(\d{6,7})-0*(\d{1,3})(?!\d)/.exec(t);
    if (s)
        return `${s[1]}-${s[2]}`;
    const h = /(?<![A-Z0-9])([A-Z]{2}-\d{4})(?![\d-])/.exec(t);
    return h ? h[1] : null;
}
//# sourceMappingURL=mrb-sn.js.map